export default "__VITE_ASSET__VNWHa$nS__"